import { render } from "./OmniBsInput.vue?vue&type=template&id=24ed37d2&scoped=true"
import script from "./OmniBsInput.vue?vue&type=script&lang=js"
export * from "./OmniBsInput.vue?vue&type=script&lang=js"

import "./OmniBsInput.vue?vue&type=style&index=0&id=24ed37d2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24ed37d2"]])

export default __exports__